import { render, staticRenderFns } from "./FundaIntroC.vue?vue&type=template&id=349fc5e3&"
import script from "./FundaIntroC.vue?vue&type=script&lang=js&"
export * from "./FundaIntroC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports